import gql from 'graphql-tag';
import programIcon from '../assets/icons/Programs.svg';

// --------------- Page title configuration --------------
const pageTitle = {
  label: 'Program:',
  dataField: 'program_acronym',
};

const pageSubTitle = {
  dataField: 'program_name',
};

// --------------- Icons configuration --------------
const programDetailIcon = {
  src: programIcon,
  alt: 'INS programs logo',
};

const externalLinkIcon = {
  src: 'https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/bento/images/icons/svgs/externalLinkIcon.svg',
  alt: 'External link icon',
};

// --------------- Data panel configuration --------------
const leftPanel = [
  {
    sectionHeader: 'Program Information',
    properties: [
      {
        label: 'Program Website',
        dataField: 'program_acronym',
        link: '{program_link}',
      },
      {
        label: 'Associated Special Topic(s)',
        dataField: 'focusAreaTransformed',
      },
      {
        label: 'Associated Cancer Types(s)',
        dataField: 'cancerTypesTransformed',
      },
      {
        label: 'Principal Investigators',
        dataField: 'contact_pi',
      },
    ],
  },
];

const rightPanel = [
  {
    sectionHeader: 'NCI Support',
    properties: [
      {
        label: 'NCI Division/Office/Center (DOC)',
        dataField: 'docTransformed',
      },
      {
        label: 'Program Officer',
        dataField: 'contact_nih',
      },
      {
        label: 'Associated Notices of Funding Opportunities (NOFO)',
        dataField: 'nofoTransformed',
      },
    ],
  },
];

// --------------- GraphQL query - Retrieve program details --------------
const GET_PROGRAM_DETAIL_DATA_QUERY = gql`
query programDetails($program_id: String) {
  programDetails(program_id: $program_id) {
      contact_nih
      contact_pi
      program_doc
      focus_area
      cancer_type
      nofo
      program_acronym
      program_link
      program_name
  }
}`;

const PROGRAM_DETAIL_QUERY = gql`
query search(
  $program_ids: [String]
) {
searchProjects(
  program_ids: $program_ids
) {
  numberOfGrants
  numberOfProjects
  numberOfPublications
}
}`;

export {
  pageTitle,
  pageSubTitle,
  programDetailIcon,
  leftPanel,
  rightPanel,
  externalLinkIcon,
  GET_PROGRAM_DETAIL_DATA_QUERY,
  PROGRAM_DETAIL_QUERY,
};
